<template>
    <component :is="component" :filterData="filterData" :sortData="sortData" v-if="component"/>
</template>

<script>
export default {
    name: "UtilityFilterLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        filterLayout: {},
        filterData: {
            default: () => {
            }
        },
        sortData: {default: () => {}},
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/utility/filter/UtilityFilterDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.filterLayout) {
                return null
            }
            return () => import(`@/template/utility/filter/${this.filterLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
